<div class="wrapper">
  <div class="emr-page-container">
    <div class="emr-page-title">{{ currentUser.firstName }}'s Student List</div>
    <div class="btn-container">
      <button pButton pRipple type="button" label="Import Students" icon="pi pi-upload"
        (click)="openImportStudentsDialog()"></button>
    </div>
    <div class="dialog-container">
      <emr-file-upload-dialog title="Import Students" [(display)]="showImportStudentsDialog"
        (dialogClose)="onCloseImportStudentsDialog($event)"></emr-file-upload-dialog>
    </div>

    <div class="dialog-container">
      <emr-confirmation-dialog title="Delete Students" [(display)]="showDeleteStudentDialog"
        (dialogClose)="onCloseDeleteStudentsDialog($event)" [confirmDisabled]="!confirmDeleteStudents">
        <p>You are about to delete the following students:</p>
        <ul>
          <li *ngFor="let student of selectedStudents">
            {{ student.firstNameLastName }} ({{ student.id }})
          </li>
        </ul>
        <p>Are you sure you would like to continue?</p>
        <p-checkbox id="confirmDeleteStudentsBox" [binary]="true" [(ngModel)]="confirmDeleteStudents" />
        <label class="label-right-of-box" for="confirmDeleteStudentsBox">
          I want to delete the above students.
        </label>
      </emr-confirmation-dialog>
    </div>

    <div class="table-container">
      <p-table #studentTable [value]="students" class="emr-table" styleClass="data-table" [loading]="isLoading"
        [rowHover]="true" [rows]="25" [showCurrentPageReport]="true" [rowsPerPageOptions]="[25, 50, 100]"
        responsiveLayout="scroll" [paginator]="true"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} students" [filterDelay]="0"
        [globalFilterFields]="tableFilterFields" [(selection)]="selectedStudents">
        <ng-template pTemplate="caption">
          <div class="table-header">
            <p-iconfield iconPosition="left">
              <p-inputicon>
                <i class="pi pi-search"></i>
              </p-inputicon>
              <input pInputText type="text" (input)="filterTable($event.target)" placeholder="Search students" />
            </p-iconfield>
            <span>
              <button pButton pRipple type="button" label="Refresh List" icon="pi pi-refresh" [loading]="isLoading"
                (click)="fetchStudents()"></button>
            </span>
          </div>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="8" style="text-align: center; padding: 3rem">
              You currently have no students. Click the "Upload Students" button to enter student
              data!
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="header">
          <tr>
            <th style="width: 3rem">
              <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
            </th>
            <th pSortableColumn="firstName">
              <div class="flex justify-content-between align-items-center">
                First Name
                <p-sortIcon field="firstName"></p-sortIcon>
                <p-columnFilter type="text" field="firstName" display="menu" class="ml-auto"></p-columnFilter>
              </div>
            </th>
            <th pSortableColumn="lastName">
              <div class="flex justify-content-between align-items-center">
                Last Name
                <p-sortIcon field="lastName"></p-sortIcon>
                <p-columnFilter type="text" field="lastName" display="menu" class="ml-auto"></p-columnFilter>
              </div>
            </th>
            <th pSortableColumn="email">
              <div class="flex justify-content-between align-items-center">
                Email
                <p-sortIcon field="email"></p-sortIcon>
                <p-columnFilter type="text" field="email" display="menu" class="ml-auto"></p-columnFilter>
              </div>
            </th>
            <th>
              <div class="flex justify-content-between align-items-center">Actions</div>
            </th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-student>
          <tr class="p-selectable-row">
            <td>
              <p-tableCheckbox [value]="student"></p-tableCheckbox>
            </td>
            <td>
              {{ student.firstName }}
            </td>
            <td>
              {{ student.lastName }}
            </td>
            <td>
              {{ student.email }}
            </td>
            <td style="text-align: center">
              <button pButton type="button" class="p-button-primary" icon="pi pi-eye" pTooltip="View student"
                (click)="openStudentDialog(student)"></button>
            </td>
          </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="8" style="text-align: center; padding: 3rem">
              You currently have no students. Click the "Upload Students" button to enter student
              data!
            </td>
          </tr>
        </ng-template>
      </p-table>

      <div class="dialog-container">
        <p-dialog header="Import Results" [(visible)]="showImportStudentsResultsDialog" [modal]="true">
          <p>There were errors for importing students:</p>
          <ul>
            @for (error of importErrors; track $index) {
            <li>
              {{ error }}
            </li>
            }
          </ul>
          <div class="justify-end">
            <p-button label="Close" (click)="showImportStudentsResultsDialog = false"></p-button>
          </div>
        </p-dialog>
      </div>
    </div>
  </div>

  <!-- Actions below the table -->
  <div class="btn-container">
    With selected students...
    <button pButton pRipple type="button" label="Assign Patients" icon="pi pi-user-edit"
      (click)="routeToAssignPatientsPage()" [disabled]="!didSelectStudents"></button>
    <button pButton pRipple type="button" label="Delete Students" class="p-button-danger" icon="pi pi-trash"
      [disabled]="!didSelectStudents" (click)="openDeleteStudentsDialog()" style="margin-left: 8px"></button>
  </div>

</div>